import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Music } from "lucide-react";
import { getSmartlink, clickSmartlink } from "@/lib/afmApi";
import { Logo } from "@/components/Logo";
import { Loading } from "@/components/common";

const DSP_COLORS = { spotify: "#1DB954", apple: "#FA243C", applemusic: "#FA243C", youtube: "#FF0000", youtubemusic: "#FF0000", amazon: "#00A8E1", amazonmusic: "#00A8E1", deezer: "#A238FF", tidal: "#000000", tiktok: "#000000" };

export default function SmartLinkLanding() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [status, setStatus] = useState("loading");

  useEffect(() => { getSmartlink(slug).then((d) => { setData(d); setStatus("ok"); }).catch(() => setStatus("error")); }, [slug]);

  const go = (t) => { clickSmartlink(slug, t.dsp || t.key).catch(() => {}); if (t.url) window.open(t.url, "_blank"); };

  if (status === "loading") return <div className="min-h-screen bg-[#0a0a0a]"><Loading /></div>;
  if (status === "error") return <div className="flex min-h-screen flex-col items-center justify-center bg-[#0a0a0a] text-white"><Logo variant="white" imgClassName="h-12 w-auto" /><p className="mt-6 text-sm text-slate-400">Enlace no disponible.</p></div>;

  const targets = data.dsp_targets || data.targets || [];
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white">
      <div className="mx-auto max-w-md px-5 py-12">
        <div className="mb-8 flex justify-center"><Logo variant="white" imgClassName="h-10 w-auto object-contain" /></div>
        <div className="overflow-hidden rounded-3xl border border-white/10 bg-white/5">
          <div className="flex aspect-square items-center justify-center bg-black">
            {data.cover_url ? <img src={data.cover_url} alt={data.title} className="h-full w-full object-cover" /> : <Music className="h-20 w-20 text-white/20" />}
          </div>
          <div className="p-7 text-center">
            <h1 className="font-serif text-3xl font-extrabold">{data.title}</h1>
            {(data.artist_name || data.main_artist) && (
              <p className="mt-1 text-sm text-slate-400" data-testid="smartlink-artist">{data.artist_name || data.main_artist}</p>
            )}
            <div className="mt-7 space-y-3" data-testid="smartlink-targets">
              {targets.map((t) => (
                <button key={t.dsp || t.key || t.store} data-testid={`dsp-${t.dsp || t.key}`} onClick={() => go(t)} className="flex w-full items-center justify-between rounded-xl border border-white/10 bg-white/5 px-5 py-3.5 text-left transition-colors hover:border-white/30">
                  <span className="flex items-center gap-3 font-semibold"><span className="h-3 w-3 rounded-full" style={{ backgroundColor: DSP_COLORS[t.dsp || t.key] || "#888" }} />{t.store || t.name || t.dsp}</span>
                  <span className="text-xs font-semibold uppercase tracking-wider text-slate-400">Reproducir</span>
                </button>
              ))}
            </div>
          </div>
        </div>
        <p className="mt-6 text-center text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500">Tecnología por SONA</p>
      </div>
    </div>
  );
}
